import React from 'react';
import { Loading } from 'react-style-guide';

function LoadingPage(): React.ReactElement {
  return <Loading />;
}
export default LoadingPage;
